<template>
<div>
  <el-form style="margin-right: 40px" :model="bedForm" :rules="bedRules" ref="bedForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="变更床位" prop="org">
      <el-cascader v-fixZoom ref="cascaderBed" v-model="bedForm.org" placeholder="请选择"
        :options="options" :props="props" :show-all-levels="false" clearable style="width: 100%" @change="changeBed">
      </el-cascader>
    </el-form-item>
    <el-form-item label="原因" prop="">
      <el-input type="textarea" :rows="2" v-model="bedForm.reason" placeholder="请输入原因"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeChangeBed()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitChangeBed('bedForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {queryhomebed} from '../../../api/yanglaoyuan'
import {queryChildrenOrgByEid, queryChildrenOrgByOrgId} from '../../../api/organizer'
import {queryOrgHomeByOrgId} from '../../../api/yanglaoyuan/orgHome'
import {accomodationchangebed} from '../../../api/yanglaoyuan/homebed'

export default {
  name: 'changeBedOpen',
  model: {
    prop: 'bedShow',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      options: [],
      props: {
        value: 'id',
        label: 'name',
        lazy: true,
        lazyLoad: async (node, resolve) => {
          let nodes = []
          // if (node.children && node.children.length === 0) {
          if (node.level === 0) {
            nodes = await this.getOrgData()
          } else if (node.data.org_type === 0 || node.data.org_type === 1) {
            nodes = await this.getOrgChildData(node.value)
          } else if (node.data.org_type === 2) {
            nodes = await this.getOrgHomeData(node.value)
          } else {
            nodes = await this.getHomeBedData(node.value)
          }
          // }
          resolve(nodes)
        }
      },
      bedArr: [],
      bedForm: {
        org: [],
        eId: 0,
        id: 0,
        epId: 0,
        espId: 0,
        espName: '',
        bidNew: 0,
        bNameNew: '',
        bidOld: 0,
        bNameOld: '',
        hidNew: 0,
        reason: ''
      },
      bedRules: {
        org: [{required: true, message: '请选择床位', trigger: 'change'}]
        // note: [{ required: true, message: '请填写原因', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      // console.log(this.listObj.row)
      if (this.listObj && this.listObj.row) {
        let loginResp = this.$store.state.user.LoginResp
        this.bedForm.eId = this.listObj.row.eid
        this.bedForm.epId = this.listObj.row.epid
        this.bedForm.espId = loginResp.syspersonid
        this.bedForm.espName = loginResp.personname
        this.bedForm.id = this.listObj.row.id
        this.bedForm.bidOld = this.listObj.row.bid
        this.bedForm.bNameOld = this.listObj.row.bed_name
        // this.getOptions()
      }
    },
    async getOptions () {
      let that = this
      let orgStr = this.listObj.row.mqttlevel + '/' + this.listObj.row.hid + '/' + this.listObj.row.bid
      let orgArr = orgStr.split('/')
      let arr = await this.getOrgData()
      let parentObj = ''
      for (let i = 3; i < orgArr.length; i++) {
        let id = parseInt(orgArr[i])
        if (i === 3) {
          parentObj = arr.find(r => r.id === id)
        } else {
          parentObj = parentObj.children.find(r => r.id === id)
        }
        if (parentObj) {
          let childArr = []
          if (parentObj.org_type === 0 || parentObj.org_type === 1) {
            childArr = await that.getOrgChildData(id)
          } else if (parentObj.org_type === 2) {
            childArr = await that.getOrgHomeData(id)
          } else {
            childArr = await that.getHomeBedData(id)
          }
          parentObj.children = childArr
        }

        this.bedForm.org.push(id)
      }
      this.options = arr
    },
    changeBed () {
      if (this.bedForm.org.length !== 0) {
        let arr = this.$refs['cascaderBed'].getCheckedNodes()[0].pathLabels
        this.bedForm.bNameNew = arr[arr.length - 1]
        this.bedForm.bidNew = this.bedForm.org[this.bedForm.org.length - 1]
        this.bedForm.hidNew = this.bedForm.org[this.bedForm.org.length - 2]
      }
    },
    closeChangeBed () {
      this.$emit('change', false)
    },
    submitChangeBed (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.bedForm.bidNew === 0 || this.bedForm.bidNew === this.bedForm.bidOld) {
            this.$message({message: '请选择新床位', type: 'warning'})
          } else {
            let data = {
              eid: this.bedForm.eId,
              id: this.bedForm.id,
              epid: this.bedForm.epId,
              esp_id: this.bedForm.espId,
              esp_name: this.bedForm.espName,
              bid_new: this.bedForm.bidNew,
              bnamenew: this.bedForm.bNameNew,
              bid_old: this.bedForm.bidOld,
              bnameold: this.bedForm.bNameOld,
              hid_new: this.bedForm.hidNew,
              reason: this.bedForm.reason
            }
            accomodationchangebed(data).then(res => {
              this.$notify({title: '成功', message: '成功变更床位', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    },

    // 访问接口
    async getOrgData () {
      let arr = []
      let data = { eid: this.listObj.row.eid }
      await queryChildrenOrgByEid(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgChildData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryChildrenOrgByOrgId(data).then(res => {
        if (res.data.org) {
          res.data.org.forEach(org => {
            org.leaf = false
            arr.push(org)
          })
        }
      })
      return arr
    },
    async getOrgHomeData (id) {
      let arr = []
      let data = {
        orgid: id
      }
      await queryOrgHomeByOrgId(data).then(res => {
        if (res.data.orghomes) {
          res.data.orghomes.forEach(orgHome => {
            orgHome.leaf = false
            orgHome.name = orgHome.room
            arr.push(orgHome)
          })
        }
      })
      return arr
    },
    async getHomeBedData (id) {
      let arr = []
      let data = {
        hid: id,
        isbind: [0]
      }
      await queryhomebed(data).then(res => {
        if (res.data.homebed) {
          res.data.homebed.forEach(homeBed => {
            homeBed.leaf = true
            homeBed.name = homeBed.bed_name
            arr.push(homeBed)
          })
        }
      })
      return arr
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/changeBedOpen.vue